export default "__VITE_ASSET__D9IxN8ri__"